export { PrivateRoute } from './PrivateRoute/PrivateRoute';

export { AccountCreated } from './AccountCreated/AccountCreated';

export { ForgotPassword } from './ForgotPassword/ForgotPassword';

export { ResetPassword } from './ResetPassword/ResetPassword';

export { Home } from './Home/Home';

export { Login } from './Login/Login';

export { Profile } from './Profile/Profile';

export { ProfileEdit } from './ProfileEdit/ProfileEdit';

export { SignUp } from './SignUp/SignUp';

export { ThankYou } from './ThankYou/ThankYou';

export { AppRouter } from './StripedRouter/StripedRouter';

export { Album } from './Album/Album';

export { Favorites } from './Favorites/Favorites';

export { Results } from './Results/Results';

export { Orders } from './Orders/Orders';

export { AboutUs } from './AboutUs/AboutUs';






// WEBPACK FOOTER //
// ./src/routes/index.js